const TOUCH_MODE_KEY = 'sauda_touch_mode'
const EVENT = 'sauda-touch-mode'

/** По умолчанию выкл. — модалка цифр только после включения в шапке. */
export function isTouchModeEnabled() {
  return localStorage.getItem(TOUCH_MODE_KEY) === '1'
}

export function setTouchModeEnabled(enabled) {
  const next = !!enabled
  localStorage.setItem(TOUCH_MODE_KEY, next ? '1' : '0')
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { enabled: next } }))
  }
  return next
}

export function onTouchModeChange(handler) {
  if (typeof window === 'undefined') return () => {}
  const listener = (event) => {
    handler(!!(event && event.detail && event.detail.enabled))
  }
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}

export function isTouchNumberInput(el) {
  if (!el || el.tagName !== 'INPUT') return false
  if (el.disabled || el.readOnly) return false
  if (el.dataset.touchPad === 'off') return false
  if (el.dataset.touchPad === 'number' || el.dataset.touchPad === 'phone') return true
  const type = (el.getAttribute('type') || '').toLowerCase()
  if (type === 'number' || type === 'tel') return true
  const mode = (el.getAttribute('inputmode') || el.inputMode || '').toLowerCase()
  return mode === 'numeric' || mode === 'decimal'
}

export function touchPadModeFor(el) {
  if (!el) return 'number'
  if (el.dataset.touchPad === 'phone' || (el.getAttribute('type') || '').toLowerCase() === 'tel') {
    return 'phone'
  }
  return 'number'
}

export function touchPadAllowDecimal(el) {
  if (!el) return false
  if (el.dataset.touchDecimal === '0') return false
  if (el.dataset.touchDecimal === '1') return true
  const mode = (el.getAttribute('inputmode') || el.inputMode || '').toLowerCase()
  if (mode === 'decimal') return true
  const step = el.getAttribute('step')
  return step === 'any' || (step && step.includes('.'))
}
